import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

// Layout import
import Layout from '@/layout/Layout'
import FinishClass from '@/pages/finish-class'
import Home from '@/pages/home'
// Components import
import Login from '@/pages/login'
import MyClass from '@/pages/my-class'
import Room from '@/pages/room'
import Room2 from '@/pages/room2'
import ScreenRecordMark from '@/pages/screenRecordMark'
import ScreenRecordControl from '@/pages/screenRecordMark/control'

export interface routerType {
  path: string
  component: ReactNode
  children?: routerType[]
}

const router: routerType[] = [
  {
    path: '/login',
    component: <Login />
  },
  {
    path: '/center',
    component: <Layout />,
    children: [
      {
        path: '/center',
        component: <Home />
      },
      {
        path: '/center/myTimeTable',
        component: <MyClass />
      },
      {
        path: '/center/finishClass',
        component: <FinishClass />
      },
      {
        path: '*',
        component: <Home />
      }
    ]
  },
  {
    path: '/room',
    component: <Room />
  },
  {
    path: '/room2',
    component: <Room2 />
  },
  {
    path: '/screenRecordMark',
    component: <ScreenRecordMark />
  },
  {
    path: '/screenRecordControl',
    component: <ScreenRecordControl />
  },

  {
    path: '*',
    component: <Navigate to="/login" />
  }
]

export default router
